// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import '../styles/Search.css'
import { useEffect, useState } from 'react';
import { useGetApi } from '../data/hooks/api';
import { RESOURCE_SERVER_URLS } from '../data/configs/spl-config';
import { SearchResultBox } from './SearchResultBox';
import { useAuthContext } from '@asgardeo/auth-react';
import * as Types from "../data/utils/types";
import Magnify from "../images/magnifying.svg";

type SearchOptions = "account" | "myAccount" | "case" | "project";

interface SearchPropsInterface {
    searchOption: SearchOptions;
    setShowTable?: (value: boolean) => void;
}

function Search(props: SearchPropsInterface) {
    const { state } = useAuthContext();
    const [inputValue, setInputValue] = useState("");
    const [searchType, setSearchType] = useState<SearchOptions>(props.searchOption);

    useEffect(() => {
        setSearchType(props.searchOption);
    }, [props.searchOption]);

    let ApiEndpoint = "";

    function SearchInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        setInputValue(event.target.value);

        if (event.target.value.length >= 4 && props.setShowTable) {
            props.setShowTable(false);
        } else {
            if (event.target.value.length === 0 && props.setShowTable) {
                props.setShowTable(true);
            }
        }
    }

    if (searchType == "account") {
        ApiEndpoint = `/accounts?phrase=${inputValue}&offset=0&limit=10`;
    } else if (searchType == "myAccount") {
        ApiEndpoint = `/accounts?email=${state.email}&phrase=${inputValue}&offset=0&limit=10`;
    } else if (searchType == "case") {
        ApiEndpoint = `/cases?phrase=${inputValue}&offset=0&limit=10`;
    } else if (searchType == "project") {
        ApiEndpoint = `/projects?phrase=${inputValue}&offset=0&limit=10`;
    }

    const apiUrl = RESOURCE_SERVER_URLS[0] + ApiEndpoint;
    const { data, getApiData } = useGetApi<Types.Search>({ url: apiUrl, headers: { "accept": "application/json" } });

    useEffect(() => {
        if (inputValue.length >= 4) {
            getApiData(apiUrl);
        }
    }, [inputValue, searchType]);

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-7">
                    <form className="card card-sm search-bar">
                        <div className="card-body row no-gutters align-items-center">
                            <div className="col">
                                <input className="form-control form-control-lg form-control-borderless"
                                    type="search" placeholder={searchType == "case" ?
                                        "Search by Case Number" : searchType == "account" || searchType == "myAccount" ?
                                            "Search by Account Name" : "Search by Project Name"} onChange={SearchInputChange}
                                />
                            </div>
                            <div className="col-auto">
                                <img src={Magnify} alt="Logo" className='magnify' />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {inputValue.length >= 4 && <SearchResultBox searchDataResponse={data} type={searchType} />}
            <br />
        </div>
    )
}

export default Search;
